
import { loadScript } from "../../../globals/constants";
import SEO from "../seo";
import { useEffect, useState } from "react";
import { getAboutusPage } from "../../../utils/func";
import PageBody from "../pageBody";

function AboutUsPage({
    siteName,
    pageTitle
}) {

    const [pageInfo,setPageInfo] = useState(null)


    useEffect(() => {
        
        getAboutusPage().then(result => {
            console.log('about us page is', result)
            setPageInfo(result[0])
        }).catch(err => {

        })
    }, [])

  
    useEffect(() => {
        loadScript("js/custom.js");
    })


    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={pageTitle}
                description=""
                keywords=""
            />

         {/* Why Choose us */}
         {/* <SectionHome3WhyChooseUs /> */}

            {
                pageInfo && pageInfo?.body && (
                    <PageBody 
                        body={JSON.parse(pageInfo?.body)}
                        formspree_id={""}
                    />
                )
            }
        
            {/*Video Section */}
            {/* <SectionHome2Video /> */}

            {/* OUR PLANS  */}
            {/* <SectionHome1Plans /> */}
        </>
    )
}
export default AboutUsPage;